import { Typography, Grid, Container, CardMedia, Card, CardContent } from '@material-ui/core';


let Error404 = () => {
    return (
        <Container maxWidth="lg">
            <Card elevation={0}>
                <CardContent>
                    <Grid container spacing={2} alignContent="center">
                        <Grid item xs>
                            <Typography align="center" variant="h1">
                                404: The page you are looking for isn’t here
                            </Typography>
                            <Typography align="center" variant="subtitle2">
                                You either tried some shady route or you came here by mistake. Whichever
                                it is, try using the navigation
                            </Typography>
                        </Grid>
                    </Grid>
                </CardContent>
                <CardMedia
                    height="500"
                    component="img"
                    image="/images/errors/404.svg"
                    style={{ objectFit: 'inherit' }}
                />
            </Card>
        </Container>
    );
};

export default Error404;